import { AuthToken } from './auth-token';

export class AuthTokenRegetResponse extends AuthToken {}
